import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('taskStatusTime', taskStatusTime);

function taskStatusTime(bringozTimeFilter) {
  return function taskStatusTimeFilter(task: any) {
    if (task.status === 'CourierDeparted') {
      return bringozTimeFilter(task, 'agentDepartureTime');
    }
    else if (task.status === 'ManualHandled') {
      return bringozTimeFilter(task, 'statusUpdatedAt');
    }
    else if (task.status === 'CourierArrived') {
      return bringozTimeFilter(task, 'agentArrivalTime');
    }
    else if (task.status === 'CourierHeading') {
      return bringozTimeFilter(task, 'agentHeadingTime');
    }
    else if (task.status === 'Canceled') {
      return bringozTimeFilter(task, 'updatedTime');
    }
    else if (task.status === 'ContactNotAvailable') {
      return task.contactNotAvailableCode;
    }
  }
}

